var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('footer', {
    staticClass: "footer"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "page-text",
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('p', {
    staticClass: "font-size-16 grey--text text--darken-4 font-weight-medium mb-8 mb-md-12 mb-lg-16 font-pretendard"
  }, [_vm._v("(주)모두에프엔티")]), _c('ul', {
    staticClass: "footer-info d-flex page-text--xs"
  }, [_c('li', {
    staticClass: "mr-16 mb-6 mb-md-0"
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Address.")]), _vm._v(" 경기도 하남시 창우로 38-35번지 ")]), _c('li', {
    staticClass: "mr-16  mb-6 mb-md-0"
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Tel.")]), _vm._v(" 02-487-7350 ")]), _c('li', {
    staticClass: "mr-16 mb-6 mb-md-0"
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("Fax.")]), _vm._v(" 02-486-2189 ")]), _c('li', [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("E-mail.")]), _vm._v(" MODOO456@NAVER.COM ")])]), _c('p', {
    staticClass: "mt-8 page-text--xs"
  }, [_vm._v("Copyright 2023. 모두에프엔티 CO.,Ltd. All Rights Reserved.")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-img', {
    staticClass: "logo mt-16 mt-md-0",
    attrs: {
      "src": "/images/logo.svg"
    }
  }), _c('div', {
    staticClass: "sns"
  }, [_c('v-btn', {
    staticClass: "grey",
    attrs: {
      "fab": "",
      "small": "",
      "href": "https://blog.naver.com/modoofnt",
      "target": "_blank"
    }
  }, [_c('v-img', {
    attrs: {
      "max-width": "20",
      "src": "/images/icon/icon-blog.png"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('u-scroll-top')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }